export const LIST = "GAME_BET_SLIP_LIST";
export const GAME_BET_SLIP_FILTER_DATA = "GAME_BET_SLIP_FILTER_DATA";
export const GAME_BET_SLIP_BET_DETAILS = "GAME_BET_SLIP_BET_DETAILS";